module.exports = __webpack_public_path__ + "img/199e6bd.svg";